import { render, staticRenderFns } from "./AlertsView.vue?vue&type=template&id=417ff24c&scoped=true&"
import script from "./AlertsView.vue?vue&type=script&lang=js&"
export * from "./AlertsView.vue?vue&type=script&lang=js&"
import style0 from "./AlertsView.vue?vue&type=style&index=0&id=417ff24c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "417ff24c",
  null
  
)

export default component.exports